import { type FileUploadOptions, useFileUpload } from './useFileUpload';

export type ImageUploadOptions = Omit<FileUploadOptions, 'accept'>;

export function useImageUpload(
  onUpload: (files: File[]) => void,
  options: ImageUploadOptions = {}
) {
  return useFileUpload(onUpload, {
    ...options,
    accept: 'image/png,image/jpeg',
  });
}
